import React from 'react';
import { Row, Col, Typography, Button, Image } from 'antd';
import { HashLink } from 'react-router-hash-link';
import Imagemain from '../../Assets/Home/NCGSA-Research-Labs.png';
import Image1 from '../../Assets/Home/LabIcons/ARSL.png';
import Image2 from '../../Assets/Home/LabIcons/G-SAGL.png';
import Image3 from '../../Assets/Home/LabIcons/GSERL.png';
import Image4 from '../../Assets/Home/LabIcons/RSGCRL.png';
import Image5 from '../../Assets/Home/LabIcons/SARL.png';
import Image6 from '../../Assets/Home/LabIcons/SDSSL.png';
import Image7 from '../../Assets/Home/LabIcons/SSTRL.png';
import '../../Styles/HomeStyles.css';

const { Title, Paragraph } = Typography;

const labIcons = [
  { src: Image6, label: 'SDSSL' },
  { src: Image5, label: 'SARL' },
  { src: Image3, label: 'GSERL' },
  { src: Image7, label: 'SSTRL' },
  { src: Image1, label: 'ARSL' },
  { src: Image2, label: 'G-SAGL' },
  { src: Image4, label: 'RSGCRL' },
];

const LabIconGroup = ({ duplicate = false }) => (
  <div className="labs-marquee__group" aria-hidden={duplicate || undefined}>
    {labIcons.map((lab) => (
      <div className="lab-icon-card" key={`${duplicate ? 'duplicate-' : ''}${lab.label}`}>
        <img src={lab.src} alt={duplicate ? '' : `${lab.label} research lab`} />
      </div>
    ))}
  </div>
);

const LabsComponent = () => {
  return (
    <section className="labs-section">
      <div className="home-section-shell">
        <Row gutter={[64, 44]} justify="space-between" align="middle">
          <Col xs={24} md={10} lg={9}>
            <div className="labs-image-container">
              <Image preview={false} src={Imagemain} alt="NCGSA research disciplines" className="labs-image" />
            </div>
          </Col>

          <Col xs={24} md={14} lg={15}>
            <Title level={2} className="labs-title">Research Labs</Title>
            <div className="section-underline" aria-hidden="true"></div>
            <Paragraph className="labs-description">
            NCGSA Research Labs are dedicated to cutting edge research in the domains varying from Geo
            Information Science, Remote Sensing, Astronomy & Astrophysics to Space Education, Global
            Navigation Satellite Systems and Small Satellite Technology. Leading researchers and scientists
            of Pakistan have come together to ensure significant contribution required towards capacity
            building at national level in GIS and Space Application Sector.
          </Paragraph>

            <div className="labs-marquee" aria-label="NCGSA research labs">
              <div className="labs-marquee__track">
                <LabIconGroup />
                <LabIconGroup duplicate />
              </div>
            </div>

            <Button type="primary" size="large" className="labs-button">
              <HashLink smooth to="/about#research-labs">Research Labs</HashLink>
            </Button>
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default LabsComponent;
